import { useState, useEffect } from 'react';
import { fetchAnmeldelser } from '../lib/cms';

const DEFAULT_REVIEWS = [
  {
    title: 'Smukke og sunde dahliaer',
    name: 'Morten Nielsen',
    city: 'Billund',
    rating: 5,
    text: 'Jeg købte dahlia-knolde her i foråret, og de har blomstret uafbrudt hele sommeren i min have. Sorterne er så smukke og sunde. Kan varmt anbefales!'
  },
  {
    title: 'Midtjyllands hyggeligste gård',
    name: 'Sofie Poulsen',
    city: 'Kolding',
    rating: 5,
    text: 'Midtjyllands absolut hyggeligste gård. Muligheden for selv at gå rundt i rækkerne og sammensætte sin egen buket er helt unik. Blomsterne holder sig friske i vasen utrolig længe.'
  },
  {
    title: 'Fantastisk service og vejledning',
    name: 'Jette Sørensen',
    city: 'Grindsted',
    rating: 5,
    text: 'Super service og fantastisk udvalg af stiklinger. Hans Jørgen gav os rigtig god vejledning om, hvordan vi bedst planter og passer vores dahliaer derhjemme.'
  },
  {
    title: 'En sand perle i Vandel',
    name: 'Henrik Jensen',
    city: 'Vandel',
    rating: 5,
    text: 'En sand perle i Vandel! Vi kommer her hvert år for at hente blomster til bordpynt til vores familiefester. Gæsterne roser altid de smukke dahliaer.'
  }
];

export default function ReviewsSlider() {
  const [reviews, setReviews] = useState(DEFAULT_REVIEWS);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    async function loadReviews() {
      try {
        const data = await fetchAnmeldelser();
        if (Array.isArray(data) && data.length > 0) {
          const active = data.filter((r) => r.vis_paa_forside !== false);
          const formatted = active.map((r) => ({
            title: r.titel || '',
            name: r.navn || '',
            city: r.by || '',
            rating: typeof r.stjerner === 'number' ? r.stjerner : 5,
            text: r.tekst || ''
          })).filter(r => r.name && r.text);

          if (formatted.length > 0) {
            setReviews(formatted);
          }
        }
      } catch (err) {
        console.error('Fejl ved hentning af anmeldelser:', err);
      }
    }
    loadReviews();
  }, []);

  const nextSlide = () => {
    if (reviews.length === 0) return;
    setCurrentIndex((prev) => (prev + 1) % reviews.length);
  };

  const prevSlide = () => {
    if (reviews.length === 0) return;
    setCurrentIndex((prev) => (prev - 1 + reviews.length) % reviews.length);
  };

  if (reviews.length === 0) return null;

  return (
    <div className="relative w-full mx-auto px-12 md:px-16">
      {/* Grid of Reviews */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
        {[0, 1, 2].map((offset) => {
          const index = (currentIndex + offset) % reviews.length;
          const review = reviews[index];
          if (!review) return null;
          return (
            <div 
              key={index} 
              className={`w-full transition-all duration-500 ease-in-out ${
                offset > 0 ? 'hidden md:block' : ''
              }`}
            >
              <div className="text-center flex flex-col items-center h-full justify-between">
                <div>
                  {/* Stjerner */}
                  <div className="flex justify-center gap-1 text-black mb-3">
                    {[...Array(review.rating)].map((_, i) => (
                      <i key={i} className="fa-solid fa-star text-sm" />
                    ))}
                  </div>

                  {/* Overskrift */}
                  {review.title && (
                    <h3 className="text-forest-950 font-serif font-bold text-lg mb-3">
                      {review.title}
                    </h3>
                  )}
                  
                  <blockquote className="text-charcoal-600 text-sm md:text-base leading-relaxed mb-6">
                    "{review.text}"
                  </blockquote>
                </div>
                
                <div className="flex flex-col items-center gap-1 mt-auto">
                  <span className="font-semibold text-forest-950 text-sm">{review.name}</span>
                  {review.city && <span className="text-xs text-charcoal-500">{review.city}</span>}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Side Navigation Arrows */}
      <button
        onClick={prevSlide}
        className="absolute left-0 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full border border-charcoal-200 hover:border-dahlia-500 hover:text-dahlia-500 text-charcoal-600 flex items-center justify-center transition-all duration-200 focus:outline-none cursor-pointer bg-white shadow-xs z-10"
        aria-label="Forrige anmeldelse"
      >
        <i className="fa-solid fa-chevron-left text-sm" />
      </button>

      <button
        onClick={nextSlide}
        className="absolute right-0 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full border border-charcoal-200 hover:border-dahlia-500 hover:text-dahlia-500 text-charcoal-600 flex items-center justify-center transition-all duration-200 focus:outline-none cursor-pointer bg-white shadow-xs z-10"
        aria-label="Næste anmeldelse"
      >
        <i className="fa-solid fa-chevron-right text-sm" />
      </button>
    </div>
  );
}
